


console.log("SEELENMATCH GUIDED V4 — PORTRAITS FIRST LOADED");

(function () {
  "use strict";

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  onReady(function () {
    const root = document.getElementById("smg-root");
    if (!root) return;

    const Engine = window.SeelenmatchEngineV2 || null;

    const state = {
      identityPayload: null,
      calculatedTop3: [],
      explorationPool: [],
      selected: [],
      ranked: [],
      access: null,
      unlockedAccess: null,
      isBonusFlow: false
    };

    function $(id) {
      return document.getElementById(id);
    }

    function showOnly(screenId) {
      document.querySelectorAll("#smg-root .smg-screen").forEach(function (screen) {
        screen.style.display = screen.id === screenId ? "block" : "none";
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function escapeHtml(value) {
      return String(value || "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }

    function writeStatus(message) {
      const el = $("smg-status-message");
      if (!el) return;
      el.style.display = message ? "block" : "none";
      el.innerHTML = message || "";
    }

    function readJsonFromStorage(storage, key) {
      try {
        return JSON.parse(storage.getItem(key) || "null");
      } catch (e) {
        return null;
      }
    }

    function createMinimalPayload() {
      return {
        version: "seelenmatch_guided_v4_portraits_first",
        createdAt: new Date().toISOString(),
        answers: {},
        meta: {
          firstname: "",
          birthdate: "",
          gender: "f",
          targetGender: "m",
          age: "40",
          preferredOrigins: ["north", "west", "south"],
          signs: ["aries", "gemini", "libra", "aquarius"]
        },
        userArchetype: {
          primaryKey: "guided_visual_choice",
          secondaryKey: "guided_visual_choice",
          primary: {
            label: "Intuitive Auswahl",
            shortLabel: "Intuitive Auswahl",
            description: "Basierend auf den Gesichtern, die deine Aufmerksamkeit spontan festhalten."
          },
          secondary: {
            label: "Emotionale Richtung",
            shortLabel: "Emotionale Richtung",
            description: "Basierend auf den Profilen, die du am liebsten wiedersehen würdest."
          }
        },
        guided: {
          selectedProfiles: [],
          rankedProfiles: []
        }
      };
    }

    function isValidPayload(payload) {
      return !!(payload && payload.meta);
    }

    function normalizePayload(payload) {
      if (!payload) return null;

      payload.meta = payload.meta || {};
      payload.answers = payload.answers || {};
      payload.userArchetype = payload.userArchetype || {};
      payload.guided = payload.guided || {};

      payload.meta.firstname = payload.meta.firstname || payload.firstname || "";
      payload.meta.birthdate = payload.meta.birthdate || payload.birthdate || "";
      payload.meta.gender = payload.meta.gender || "f";
      payload.meta.targetGender = payload.meta.targetGender || "m";
      payload.meta.age = payload.meta.age || "40";
      payload.meta.preferredOrigins = payload.meta.preferredOrigins || ["north", "west", "south"];
      payload.meta.signs = payload.meta.signs || ["aries", "gemini", "libra", "aquarius"];

      payload.userArchetype.primaryKey = payload.userArchetype.primaryKey || "guided_visual_choice";
      payload.userArchetype.secondaryKey = payload.userArchetype.secondaryKey || "guided_visual_choice";

      payload.userArchetype.primary = payload.userArchetype.primary || {
        label: "Intuitive Auswahl",
        shortLabel: "Intuitive Auswahl",
        description: "Basierend auf deiner spontanen Portrait-Auswahl."
      };

      payload.userArchetype.secondary = payload.userArchetype.secondary || {
        label: "Emotionale Richtung",
        shortLabel: "Emotionale Richtung",
        description: "Basierend auf den Gesichtern, die du am liebsten wiedersehen würdest."
      };

      return payload;
    }

    function savePayload(payload) {
      try {
        const normalized = normalizePayload(payload);
        const serialized = JSON.stringify(normalized);

        localStorage.setItem("sm_identity_payload_v2", serialized);
        localStorage.setItem("sm_identity_payload_v2_1", serialized);
        localStorage.setItem("sm_identity_payload_v2_4", serialized);

        sessionStorage.setItem("sm_identity_payload_v2", serialized);
        sessionStorage.setItem("sm_identity_payload_v2_1", serialized);
        sessionStorage.setItem("sm_identity_payload_v2_4", serialized);
      } catch (e) {
        console.warn("GUIDED V4 payload save failed", e);
      }
    }

    function decodeBase64Payload(encoded) {
      try {
        const clean = encoded.replace(/-/g, "+").replace(/_/g, "/");
        const binary = window.atob(clean);
        const bytes = Uint8Array.from(binary, function (char) {
          return char.charCodeAt(0);
        });
        const json = new TextDecoder("utf-8").decode(bytes);
        return JSON.parse(json);
      } catch (e1) {
        try {
          const json = decodeURIComponent(escape(window.atob(encoded)));
          return JSON.parse(json);
        } catch (e2) {
          return null;
        }
      }
    }

    function readPayloadFromHash() {
      const hash = window.location.hash || "";
      const marker = "smPayload=";

      if (!hash.includes(marker)) return null;

      const encoded = hash.split(marker)[1].split("&")[0];
      if (!encoded) return null;

      return normalizePayload(decodeBase64Payload(encoded));
    }

    function readIdentityPayload() {
      const hashPayload = readPayloadFromHash();
      if (isValidPayload(hashPayload)) return hashPayload;

      const keys = [
        "sm_identity_payload_v2_1",
        "sm_identity_payload_v2_4",
        "sm_identity_payload_v2",
        "sm_quiz_payload_v7",
        "sm_quiz_payload",
        "sm_payload"
      ];

      for (const key of keys) {
        const localPayload = normalizePayload(readJsonFromStorage(localStorage, key));
        if (isValidPayload(localPayload)) return localPayload;

        const sessionPayload = normalizePayload(readJsonFromStorage(sessionStorage, key));
        if (isValidPayload(sessionPayload)) return sessionPayload;
      }

      return createMinimalPayload();
    }

    function readAccessFromUrl() {
      const searchParams = new URLSearchParams(window.location.search);
      const hashParams = new URLSearchParams((window.location.hash || "").replace("#", ""));
      const access = searchParams.get("access") || hashParams.get("access");

      if (access === "top1" || access === "top3") return access;
      return null;
    }

    function readDirectFromUrl() {
      const searchParams = new URLSearchParams(window.location.search);
      const hashParams = new URLSearchParams((window.location.hash || "").replace("#", ""));

      return searchParams.get("direct") === "reveal" || hashParams.get("direct") === "reveal";
    }

    function readBonusFlowFromUrl() {
      const searchParams = new URLSearchParams(window.location.search);
      const hashParams = new URLSearchParams((window.location.hash || "").replace("#", ""));
      const path = window.location.pathname || "";

      return (
        searchParams.get("mode") === "bonus" ||
        searchParams.get("bonus") === "1" ||
        hashParams.get("mode") === "bonus" ||
        hashParams.get("bonus") === "1" ||
        path.indexOf("seelenmatch-guided-2") !== -1
      );
    }

    function shuffle(items, seed) {
      const arr = items.slice();
      let h = 2166136261;

      for (let i = 0; i < seed.length; i++) {
        h ^= seed.charCodeAt(i);
        h = Math.imul(h, 16777619);
      }

      function rnd() {
        h += 0x6D2B79F5;
        let t = h;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      }

      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(rnd() * (i + 1));
        const tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }

      return arr;
    }



    function buildImplicitUserArchetypeFromChoices(payload) {
  const answers = payload.answers || {};

  const chosenKeys = [
    answers.visual_choice_1,
    answers.visual_choice_2,
    answers.visual_choice_3
  ].filter(Boolean);

  if (!chosenKeys.length || !Engine || !Engine.matchingMatrix || !Engine.userArchetypes) {
    return payload;
  }

  const userScores = {};

  Object.keys(Engine.userArchetypes).forEach(function(userKey) {
    userScores[userKey] = 0;
  });

  chosenKeys.forEach(function(portraitKey, index) {
    const weight = index === 0 ? 3 : index === 1 ? 2 : 1;

    Object.keys(Engine.matchingMatrix).forEach(function(userKey) {
      const score = Engine.matchingMatrix[userKey]?.[portraitKey] || 0;
      userScores[userKey] += score * weight;
    });
  });

  const sorted = Object.keys(userScores)
    .map(function(key) {
      return {
        key: key,
        score: userScores[key],
        archetype: Engine.userArchetypes[key]
      };
    })


    .sort(function(a, b) {
      return b.score - a.score;
    });

  const primary = sorted[0];
  const secondary = sorted[1];

  payload.userArchetype = {
    scores: userScores,
    sorted: sorted,
    primaryKey: primary ? primary.key : null,
    secondaryKey: secondary ? secondary.key : null,
    primary: primary ? primary.archetype : null,
    secondary: secondary ? secondary.archetype : null
  };

  return payload;
}




function buildCalculatedTop3(payload) {
  if (!Engine) return [];

  const enrichedPayload = buildImplicitUserArchetypeFromChoices(payload);

  const pool = Engine.buildPortraitPool({
    targetGender: enrichedPayload.meta.targetGender || "m",
    age: enrichedPayload.meta.age || "40",
    origins: enrichedPayload.meta.preferredOrigins || ["north", "west", "south"],
    signs: enrichedPayload.meta.signs || ["aries", "gemini", "libra", "aquarius"]
  });

  if (typeof Engine.rankPortraits === "function") {
    return Engine.rankPortraits(enrichedPayload, pool, { maxRanks: 3 });
  }

  return pool.slice(0, 3);
}


    

function buildExplorationPool(payload) {
  if (!Engine) return [];

  const fullPool = Engine.buildPortraitPool({
    targetGender: payload.meta.targetGender || "m",
    age: payload.meta.age || "40",
    origins: ["south", "north", "west"],
    signs: payload.meta.signs || ["aries", "gemini", "libra", "aquarius"]
  });

  const seed = [
    "guided-v36-strict-no-duplicates",
    payload.meta.firstname || "",
    payload.meta.birthdate || "",
    payload.userArchetype.primaryKey || "",
    payload.userArchetype.secondaryKey || "",
    Date.now(),
    Math.random()
  ].join("|");

  const selected = [];
  const usedIds = new Set();
  const usedVisualKeys = new Set();

  function visualKey(profile) {
    return [
      profile.letter,
      profile.gender
    ].join("-");
  }

  function addStrict(profile) {
    if (!profile) return false;
    if (usedIds.has(profile.id)) return false;

    const key = visualKey(profile);
    if (usedVisualKeys.has(key)) return false;

    selected.push(profile);
    usedIds.add(profile.id);
    usedVisualKeys.add(key);
    return true;
  }

  const groups = {
    warm: ["southern_echo", "burning_horizon", "gentle_storm"],
    still: ["winter_letter", "hidden_lighthouse", "autumn_promise"],
    deep: ["forgotten_poet", "midnight_passenger"]
  };

  Object.keys(groups).forEach(function (groupKey) {
    const candidates = shuffle(
      fullPool.filter(function (profile) {
        return groups[groupKey].includes(profile.portraitArchetypeKey);
      }),
      seed + "|" + groupKey
    );

    candidates.forEach(function (profile) {
      if (selected.length >= 9) return;
      addStrict(profile);
    });
  });

  if (selected.length < 9) {
    const extras = shuffle(fullPool, seed + "|strict-extras");

    extras.forEach(function (profile) {
      if (selected.length >= 9) return;
      addStrict(profile);
    });
  }

  return selected.slice(0, 9);
}




    function archetypeLabel(profile) {
      return profile?.portraitArchetype?.label || "Portrait";
    }

    function imageHtml(profile, locked) {
      const lock = locked ? `
        <div class="smg-lock">
          <strong>Verborgenes Profil</strong>
          <span>Dieses Gesicht wird nach der Freischaltung sichtbar.</span>
        </div>
      ` : "";

      return `
        <img
          src="${escapeHtml(profile.image)}"
          data-fallback-src="${escapeHtml(profile.fallbackImage || "")}"
          alt="${escapeHtml(archetypeLabel(profile))}"
          loading="lazy"
          onerror="if(!this.dataset.triedFallback && this.dataset.fallbackSrc){this.dataset.triedFallback='1';this.src=this.dataset.fallbackSrc;}"
        />
        ${lock}
      `;
    }

    function cardHtml(profile, options) {
      const opts = options || {};
      const selected = opts.selected ? " is-selected" : "";
      const ranked = opts.ranked ? " is-ranked" : "";
      const locked = opts.locked ? " is-locked" : "";
      const rank = opts.rank ? `<div class="smg-card-rank">${escapeHtml(opts.rank)}</div>` : "";
      const buttonAttrs = opts.clickable ? `data-id="${escapeHtml(profile.id)}"` : "";

      return `
        <article class="smg-card${selected}${ranked}${locked}" ${buttonAttrs}>
          ${rank}
          ${imageHtml(profile, opts.locked)}
          <h4>${escapeHtml(archetypeLabel(profile))}</h4>
          <p>${escapeHtml(profile.portraitArchetype?.description || "")}</p>
        </article>
      `;
    }

    function updateSelectionUi() {
      const hint = $("smg-selection-hint");
      const validate = $("smg-validate-selection");

      document.querySelectorAll("#smg-portrait-grid .smg-card").forEach(function (card) {
        const id = card.getAttribute("data-id");
        card.classList.toggle("is-selected", state.selected.some(function (item) {
          return item.id === id;
        }));
      });

      if (hint) {
        hint.textContent = state.selected.length === 3
          ? "Perfekt. Bestätige jetzt deine 3 Gesichter."
          : "Wähle 3 Gesichter, die deinen Blick sofort festhalten. Aktuell: " + state.selected.length + " von 3.";
      }

      if (validate) {
        validate.disabled = state.selected.length !== 3;
      }
    }

    function refreshPortraits() {
      state.explorationPool = buildExplorationPool(state.identityPayload);
      renderExploration();
    }

    function renderExploration() {
      const mount = $("smg-portrait-grid");
      if (!mount) return;

      state.selected = [];
      state.ranked = [];

      mount.innerHTML = state.explorationPool.map(function (profile) {
        return cardHtml(profile, { clickable: true });
      }).join("");

      mount.querySelectorAll(".smg-card").forEach(function (card) {
        card.addEventListener("click", function () {
          const id = this.getAttribute("data-id");
          const profile = state.explorationPool.find(function (item) {
            return item.id === id;
          });

          if (!profile) return;

          const exists = state.selected.some(function (item) {
            return item.id === id;
          });

          if (exists) {
            state.selected = state.selected.filter(function (item) {
              return item.id !== id;
            });
          } else {
            if (state.selected.length >= 3) return;
            state.selected.push(profile);
          }

          updateSelectionUi();
        });
      });

      updateSelectionUi();
      showOnly("smg-exploration");
    }

    function renderRanking() {
      const mount = $("smg-ranking-grid");
      const hint = $("smg-ranking-hint");
      const validate = $("smg-validate-ranking");

      if (!mount) return;

      state.ranked = [];

      function updateRankingUi() {
        mount.querySelectorAll(".smg-card").forEach(function (card) {
          const id = card.getAttribute("data-id");
          const index = state.ranked.findIndex(function (item) {
            return item.id === id;
          });
          const rankEl = card.querySelector(".smg-card-rank");

          card.classList.toggle("is-ranked", index >= 0);

          if (rankEl) {
            rankEl.textContent = index >= 0 ? String(index + 1) : "";
          }
        });

        if (hint) {
          hint.textContent = state.ranked.length === 3
            ? "Rangfolge vollständig."
            : "Klicke deine 3 Gesichter in der Reihenfolge an: " + state.ranked.length + " von 3.";
        }

        if (validate) {
          validate.disabled = state.ranked.length !== 3;
        }
      }

      mount.innerHTML = state.selected.map(function (profile) {
        return `
          <article class="smg-card" data-id="${escapeHtml(profile.id)}">
            <div class="smg-card-rank"></div>
            ${imageHtml(profile, false)}
            <h4>${escapeHtml(archetypeLabel(profile))}</h4>
            <p>${escapeHtml(profile.portraitArchetype?.description || "")}</p>
          </article>
        `;
      }).join("");

      mount.querySelectorAll(".smg-card").forEach(function (card) {
        card.addEventListener("click", function () {
          const id = this.getAttribute("data-id");
          const profile = state.selected.find(function (item) {
            return item.id === id;
          });

          if (!profile) return;

          const exists = state.ranked.some(function (item) {
            return item.id === id;
          });

          if (exists) {
            state.ranked = state.ranked.filter(function (item) {
              return item.id !== id;
            });
          } else {
            if (state.ranked.length >= 3) return;
            state.ranked.push(profile);
          }

          updateRankingUi();
        });
      });

      updateRankingUi();
      showOnly("smg-ranking");
    }

    function updatePayloadFromGuidedChoices() {
      const payload = state.identityPayload || createMinimalPayload();

      payload.guided = payload.guided || {};
      payload.guided.selectedProfiles = state.selected.map(function (p) {
        return {
          id: p.id,
          image: p.image,
          portraitArchetypeKey: p.portraitArchetypeKey || "",
          label: archetypeLabel(p)
        };
      });

      payload.guided.rankedProfiles = state.ranked.map(function (p, index) {
        return {
          rank: index + 1,
          id: p.id,
          image: p.image,
          portraitArchetypeKey: p.portraitArchetypeKey || "",
          label: archetypeLabel(p)
        };
      });

      payload.answers = payload.answers || {};
      payload.answers.visual_choice_1 = state.ranked[0]?.portraitArchetypeKey || "";
      payload.answers.visual_choice_2 = state.ranked[1]?.portraitArchetypeKey || "";
      payload.answers.visual_choice_3 = state.ranked[2]?.portraitArchetypeKey || "";

      state.identityPayload = normalizePayload(payload);
      savePayload(state.identityPayload);
    }

    function enrichPayloadWithFinalForm() {
      const firstnameInput = $("smg-final-firstname");
      const birthdateInput = $("smg-final-birthdate");

      const firstname = firstnameInput ? firstnameInput.value.trim() : "";
      const birthdate = birthdateInput ? birthdateInput.value.trim() : "";

      if (!birthdate) {
        writeStatus("Bitte gib dein Geburtsdatum ein, bevor du deine Enthüllung freischaltest.");
        if (birthdateInput) birthdateInput.focus();
        return false;
      }

      state.identityPayload.meta.firstname = firstname;
      state.identityPayload.meta.birthdate = birthdate;

      const year = Number(String(birthdate).slice(0, 4));
      const currentYear = new Date().getFullYear();

      if (year && year > 1900 && year <= currentYear) {
        const age = Math.max(18, Math.min(70, currentYear - year));
        state.identityPayload.meta.age = String(Math.round(age / 10) * 10);
      }

      updatePayloadFromGuidedChoices();
      savePayload(state.identityPayload);
      return true;
    }

    function renderConfrontation() {
      const intuitiveMount = $("smg-intuitive-top3");
      const calculatedMount = $("smg-calculated-top3");
      const note = $("smg-confrontation-note");

      if (!intuitiveMount || !calculatedMount) return;

      updatePayloadFromGuidedChoices();

      state.calculatedTop3 = buildCalculatedTop3(state.identityPayload);

      intuitiveMount.innerHTML = state.ranked.map(function (profile, index) {
        return cardHtml(profile, {
          ranked: true,
          rank: index + 1,
          clickable: false
        });
      }).join("");

      calculatedMount.innerHTML = state.calculatedTop3.map(function (profile, index) {
        return cardHtml(profile, {
          ranked: true,
          rank: index + 1,
          locked: true,
          clickable: false
        });
      }).join("");

      if (note) {
        note.innerHTML = "";
        note.style.display = "none";
      }

  
      try {
        localStorage.setItem("sm_guided_ranked_profiles", JSON.stringify(state.ranked));
        sessionStorage.setItem("sm_guided_ranked_profiles", JSON.stringify(state.ranked));
      } catch (e) {
        console.warn("Could not save ranked profiles", e);
      }

      showOnly("smg-confrontation");
    }


    function saveSeelenmatchToCart(accessLevel) {
      if (!enrichPayloadWithFinalForm()) {
        return Promise.resolve(false);
      }

      const payload = JSON.stringify(state.identityPayload);

      return fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            sm_payload: payload,
            sm_access: accessLevel
          }
        })
      })
        .then(function () {
          return true;
        })
        .catch(function (error) {
          console.error("Cart attributes save failed", error);
          writeStatus("Ein technischer Fehler ist aufgetreten. Bitte versuche es erneut.");
          return false;
        });
    }



function renderPaidReveal() {
  document.querySelectorAll(".smg-final-step, #smg-final-step").forEach(function(el){
    el.remove();
  });

  const intuitiveMount = $("smg-intuitive-top3");
  const calculatedMount = $("smg-calculated-top3");
  const note = $("smg-confrontation-note");

  if (!intuitiveMount || !calculatedMount) return;

  const access = state.unlockedAccess || state.access || "top1";

  let intuitiveProfiles = state.ranked || [];

  if (!intuitiveProfiles.length) {
    try {
      intuitiveProfiles = JSON.parse(localStorage.getItem("sm_guided_ranked_profiles") || "[]");
    } catch (e) {
      intuitiveProfiles = [];
    }
  }

  const calculatedProfiles = access === "top3"
    ? state.calculatedTop3.slice(0, 3)
    : state.calculatedTop3.slice(0, 1);

  function sameProfile(a, b) {
    if (!a || !b) return false;

    return (
      a.id === b.id ||
      a.portraitArchetypeKey === b.portraitArchetypeKey
    );
  }


function getIntuitiveMatchScore(intuitiveProfile, intuitiveIndex) {
  const matchIndex = calculatedProfiles.findIndex(function (calculatedProfile) {
    return sameProfile(intuitiveProfile, calculatedProfile);
  });

  if (matchIndex === -1) return 0;

  const distance = Math.abs(intuitiveIndex - matchIndex);

  if (distance === 0) return 100;
  if (distance === 1) return 50;
  if (distance === 2) return 25;

  return 0;
}


  function commentForIntuitiveProfile(intuitiveProfile, index) {
  const number = index + 1;
  const score = getIntuitiveMatchScore(intuitiveProfile, index);

  if (score === 100) {
    return `
      <div class="smg-paid-comment">
        <strong>${number}. Portraitvergleich</strong><br>
        Dieses Portrait entspricht genau dem ersten berechneten Profil.
        Deine spontane Auswahl und das Ergebnis von Seelenmatch zeigen hier dieselbe Richtung.
      </div>
    `;
  }

  if (score === 50) {
    return `
      <div class="smg-paid-comment">
        <strong>${number}. Portraitvergleich</strong><br>
        Dieses Portrait erscheint ebenfalls in deinem Ergebnis,
        jedoch nicht an erster Stelle.
        Deine Auswahl liegt also nahe an dem Profil,
        das Seelenmatch für dich ermittelt hat.
      </div>
    `;
  }

  if (score === 25) {
    return `
      <div class="smg-paid-comment">
        <strong>${number}. Portraitvergleich</strong><br>
        Dieses Portrait gehört ebenfalls zu den berechneten Profilen,
        erscheint jedoch weiter hinten im Ergebnis.
        Es besteht also eine erkennbare Verbindung zwischen deiner Auswahl und deiner Enthüllung.
      </div>
    `;
  }

  return `
    <div class="smg-paid-comment">
      <strong>${number}. Portraitvergleich</strong><br>
      Dieses Portrait erscheint nicht unter den berechneten Profilen.
      Vergleiche die beiden Gesichter und beobachte,
      welches dich heute stärker anspricht.
    </div>
  `;
}



  intuitiveMount.innerHTML = intuitiveProfiles.slice(0, 3).map(function (profile, index) {
    return cardHtml(profile, {
      ranked: true,
      rank: index + 1,
      locked: false,
      clickable: false
    });
  }).join("");

  calculatedMount.innerHTML = calculatedProfiles.map(function (profile, index) {
    return cardHtml(profile, {
      ranked: true,
      rank: index + 1,
      locked: false,
      clickable: false
    });
  }).join("");

const comments = intuitiveProfiles.slice(0, 3).map(function (intuitiveProfile, index) {
  return commentForIntuitiveProfile(intuitiveProfile, index);
}).join("");

if (note) {
  note.style.display = "block";

  note.innerHTML = `

    <div class="smg-paid-unlocked-message">

      <div class="smg-paid-unlocked-message">
        <strong>
          Deine Enthüllung wurde freigeschaltet.
        </strong>
      </div>

      <div class="smg-paid-analysis-title">
        Deine Auswahl und deine Enthüllung
      </div>

      <div class="smg-paid-comment">
        Links siehst du die Gesichter,
        die dich spontan berührt haben.

        <br><br>

        Rechts siehst du die Gesichter von Männern,
        denen du begegnen könntest.

        <br><br>

        Vergleiche beide Seiten
        und entdecke, welche Gesichter bei dir die stärkste Wirkung auslösen.
      </div>

      <div class="smg-paid-comments-wrap">
        ${comments}
      </div>



      ${state.isBonusFlow ? `
      <div class="smg-paid-bonus-box">
        <div class="smg-paid-bonus-title">
          Bonus-Auswertung abgeschlossen.
        </div>

        <div class="smg-paid-bonus-text">
          Deine zweite Auswahl wurde bereits ausgewertet.
        </div>

        <a class="smg-bonus-btn" href="/pages/seelenmatch-game">
          Mini-Game starten
        </a>
      </div>
      ` : `
      <div class="smg-paid-bonus-box">
        <div class="smg-paid-bonus-title">
          Bonus freigeschaltet
        </div>

        <div class="smg-paid-bonus-text">
          Du kannst jetzt einen zweiten Portrait-Test durchführen
          und vergleichen, ob du dieselben Gesichter erneut auswählst.
        </div>

        <a class="smg-bonus-btn" href="/pages/seelenmatch-quiz-2?mode=bonus">
          Bonus-Portrait-Test starten
        </a>

        <div style="margin-top:18px;text-align:center;">
          <a href="https://cdn.shopify.com/s/files/1/0620/2572/8250/files/Trainingsleitfaden-ebook.pdf?v=1765326476"
             target="_blank"
             style="display:inline-block;width:620px;max-width:94%;background:#000;color:#fff;padding:18px 24px;border-radius:10px;text-decoration:none;font-size:16px;font-weight:700;line-height:1.45;text-align:center;">
             Ebook: Trainingsleitfaden – Wie kann ich einen Mann verführen?
          </a>
        </div>
      </div>
      `}

      <style>
        .smg-paid-unlocked-message {
          text-align: center;
          margin: 18px auto 14px;
          font-size: 15px;
          color: #222;
        }

        .smg-paid-analysis-title {
          text-align: center;
          margin: 12px auto 18px;
          font-size: 15px;
          font-weight: 700;
          color: #d63384;
        }

        .smg-paid-comment {
          max-width: 760px;
          margin: 18px auto 0;
          text-align: center;
          font-size: 16px;
          line-height: 1.75;
          color: #5f4050;
          background: rgba(255,255,255,0.82);
          border: 1px solid rgba(214, 51, 132, 0.22);
          border-radius: 16px;
          padding: 18px 22px;
        }

        .smg-paid-bonus-box {
          max-width: 760px;
          margin: 28px auto 0;
          text-align: center;
          background: #fff7fb;
          border: 1px solid rgba(214, 51, 132, 0.18);
          border-radius: 20px;
          padding: 24px 22px;
        }

        .smg-paid-bonus-title {
          font-size: 18px;
          font-weight: 800;
          color: #d63384;
          margin-bottom: 12px;
        }

        .smg-paid-bonus-text {
          font-size: 15px;
          line-height: 1.65;
          color: #5f4050;
          margin-bottom: 18px;
        }

        .smg-bonus-btn {
          display: inline-block;
          background: #d63384;
          color: #fff;
          padding: 14px 22px;
          border-radius: 999px;
          text-decoration: none;
          font-weight: 800;
        }
      </style>
    `;
  }

  const buyTop3 = $("smg-buy-top3");
  const buyTop1 = $("smg-buy-top1");
  const backRanking = $("smg-back-to-ranking");

  if (buyTop3) buyTop3.style.display = "none";
  if (buyTop1) buyTop1.style.display = "none";
  if (backRanking) backRanking.style.display = "none";

  showOnly("smg-confrontation");
}




function bindStaticButtons() {
      const refresh = $("smg-refresh-portraits");
      if (refresh) {
        refresh.onclick = function () {
          refreshPortraits();
        };
      }

      const reset = $("smg-reset-selection");
      if (reset) {
        reset.onclick = function () {
          state.selected = [];
          state.ranked = [];
          updateSelectionUi();
        };
      }

      const validate = $("smg-validate-selection");
      if (validate) {
        validate.onclick = function () {
          if (state.selected.length !== 3) return;
          renderRanking();
        };
      }

      const backExploration = $("smg-back-to-exploration");
      if (backExploration) {
        backExploration.onclick = function () {
          renderExploration();
        };
      }

      const validateRanking = $("smg-validate-ranking");
      if (validateRanking) {
        validateRanking.onclick = function () {
          if (state.ranked.length !== 3) return;

          if (state.isBonusFlow) {
            state.access = "top3";
            state.unlockedAccess = "top3";
            renderPaidReveal();
            return;
          }

          renderConfrontation();
        };
      }

      const backRanking = $("smg-back-to-ranking");
      if (backRanking) {
        backRanking.onclick = function () {
          renderRanking();
        };
      }

const buyTop3 = $("smg-buy-top3");
if (buyTop3) {
  buyTop3.onclick = function () {
    saveSeelenmatchToCart("top3").then(function (ok) {
      if (!ok) return;

      window._learnq = window._learnq || [];
      window._learnq.push(["track", "Clicked Paywall Top3"]);

      setTimeout(function () {
        window.location.href = "/cart/52528448864592:1";
      }, 500);
    });
  };
}

const buyTop1 = $("smg-buy-top1");
if (buyTop1) {
  buyTop1.onclick = function () {
    saveSeelenmatchToCart("top1").then(function (ok) {
      if (!ok) return;

      window._learnq = window._learnq || [];
      window._learnq.push(["track", "Clicked Paywall Top1"]);

      setTimeout(function () {
        window.location.href = "/cart/52643448553808:1";
      }, 500);
    });
  };
}

      
const showFemaleBtn = $("smg-show-female");

if (showFemaleBtn) {
  showFemaleBtn.onclick = function () {
    state.identityPayload = normalizePayload(state.identityPayload || createMinimalPayload());
    state.identityPayload.meta = state.identityPayload.meta || {};

    const currentTarget = state.identityPayload.meta.targetGender || "m";
    const nextTarget = currentTarget === "f" ? "m" : "f";

    state.identityPayload.meta.gender = nextTarget === "f" ? "m" : "f";
    state.identityPayload.meta.targetGender = nextTarget;

    showFemaleBtn.textContent = nextTarget === "f"
      ? "Männliche Profile anzeigen"
      : "Weibliche Profile anzeigen";

    state.selected = [];
    state.ranked = [];

    state.calculatedTop3 = buildCalculatedTop3(state.identityPayload);
    state.explorationPool = buildExplorationPool(state.identityPayload);
    renderExploration();
  };
}


    }



    function init() {
      bindStaticButtons();

      if (!Engine) {
        writeStatus("SeelenmatchEngineV2 wurde nicht geladen. Bitte assets/seelenmatch-engine.js prüfen.");
        return;
      }

      const access = readAccessFromUrl();
      const directReveal = readDirectFromUrl();
      const isBonusFlow = readBonusFlowFromUrl();

      state.isBonusFlow = isBonusFlow;

      if (access === "top1" || access === "top3") {
        state.access = access;
        state.unlockedAccess = access;
      }

      state.identityPayload = normalizePayload(readIdentityPayload());
      savePayload(state.identityPayload);

      state.calculatedTop3 = buildCalculatedTop3(state.identityPayload);
      state.explorationPool = buildExplorationPool(state.identityPayload);

      if (!state.calculatedTop3.length || !state.explorationPool.length) {
        writeStatus("Die Portraits konnten nicht geladen werden. Bitte seelenmatch-engine.js und die Bildpfade prüfen.");
        return;
      }

      if (directReveal && state.unlockedAccess) {
        renderPaidReveal();
        return;
      }

      renderExploration();
    }

    init();
  });
})();